/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteProjectInput = {
    id: string;
    deleteAllProjects?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteProjectMutationVariables = {
    input: DeleteProjectInput;
};
export type deleteProjectMutationResponse = {
    readonly deleteProject: {
        readonly deletedProjectId: string | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type deleteProjectMutation = {
    readonly response: deleteProjectMutationResponse;
    readonly variables: deleteProjectMutationVariables;
};



/*
mutation deleteProjectMutation(
  $input: DeleteProjectInput!
) {
  deleteProject(input: $input) {
    deletedProjectId
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteProjectInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProjectPayload",
    "kind": "LinkedField",
    "name": "deleteProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedProjectId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteProjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteProjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteProjectMutation",
    "operationKind": "mutation",
    "text": "mutation deleteProjectMutation(\n  $input: DeleteProjectInput!\n) {\n  deleteProject(input: $input) {\n    deletedProjectId\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd7ebc8a160bdf195b10a51faba528e4a';
export default node;
